import React from 'react';

const Body = ({ getTableBodyProps, children }) => (
  <tbody {...getTableBodyProps()}>{children}</tbody>
);

export default Body;
